module.exports = __webpack_public_path__ + "img/Google-play.971d1c70.png";